import { ErrorHandler, inject, Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { NotificationService } from '@services/utils/notification.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandler extends ErrorHandler {
    private readonly notificationService = inject(NotificationService);
    private readonly translateService = inject(TranslateService);

    handleError(error: any): void {
        if (!error) {
            return;
        }

        const chunkFailedMessage = /Loading chunk [\s\S]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;
        const errorMessage = `${error.message ?? ''} ${error.rejection?.message ?? ''}`;
        if (chunkFailedMessage.test(errorMessage)) {
            this.notificationService.showErrorMessage(this.translateService.instant('loading_chunk_failed'));
            const redirectOnChunkFail = sessionStorage.getItem('redirectOnChunkFail');
            if (!redirectOnChunkFail) {
                sessionStorage.setItem('redirectOnChunkFail', 'true');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
        }
        super.handleError(error);
    }
}
